module.exports = __webpack_public_path__ + "static/media/LogoFacturation.bcd1f6b7.svg";